import React from "react";
import { useLanguage } from "../utils/LanguageContext";
import en from "../utils/languages/en.jsx";
import fr from "../utils/languages/fr.jsx";

const Projects = ({ theme }) => {
  const { language } = useLanguage();

  const translations = {
    en,
    fr,
  };

  const currentTranslations = translations[language];

  return (
    <section className="flex flex-col" id="projects">
      <div className="w-16 h-2 rounded-full bg-gradient-to-r from-violet-500 to-sky-500 sm:mt-10 sm:ml-2"></div>
      <div>
        <h2 className={`${theme === "dark" ? "title-dark" : "title"}`}>
          {currentTranslations.projectTitle}
        </h2>
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,minmax(18rem,1fr))] gap-x-8 gap-y-10">
        {currentTranslations.cards.map(
          ({ image, info, technologies, title, id, code, live }) => (
            <div
              key={id}
              className="h-full shadow-xl rounded-lg bg-gray-800 dark:bg-gray-800 p-4 flex flex-col justify-center items-center cursor-pointer transform transition duration-700 ease-in-out hover:scale-[1.1]"
            >
              <img src={image} alt="img" />
              <div className="px-2">
                <h3 className="xxxs:text-lg xxs:text-lg xs:text-xl sm:text-xl py-2 font-bold">
                  {title}
                </h3>
                <p className="text-gray-400 xxxs:text-sm xxs:text-sm xs:text-sm sm:text-sm md:text-lg dark:text-slate-300">
                  {info}
                </p>
                <p className="xxxs:text-lg xxs:text-lg  xs:text-lg sm:text-lg py-2 transition hover:duration-700 ease-in-out delay-150 dark:text-white dark:font-bold">
                  Technologies
                </p>
                <ul className="flex flex-row gap-x-2">
                  {technologies.map((tech, index) => (
                    <li
                      key={index}
                      className="text-gray-400 dark:text-slate-300 bg-slate-900/40 rounded-full px-1 py-1 transition hover:duration-700 ease-in-out delay-150 dark:bg-slate-900/40 xxxs:text-xs xxs:text-xs xs:text-xs sm:text-xs md:text-sm"
                    >
                      {tech}
                    </li>
                  ))}
                </ul>
                <div className="flex justify-between text-lg py-4 xxxs:text-sm xxs:text-sm xs:text-sm sm:text-sm">
                  <a
                    href={live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
            bg-gradient-to-r from-orange-300 to-slate-500 px-4 xs:px-3 md:px-3 py-2 rounded-lg shadow-lg hover:shadow-xl hover:bg-gray-600 hover:text-white
            "
                  >
                    {language === "en" ? "Live Demo" : "Démo en direct"}
                  </a>
                  <a
                    href={code}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
            bg-gradient-to-r from-orange-300 to-slate-500 px-4 md:px-3 py-2 rounded-lg shadow-lg hover:shadow-xl hover:bg-gray-600 hover:text-white
            "
                  >
                    {/* Source Code */}
                    {language === "en" ? "Source Code" : "Code source"}
                  </a>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default Projects;
